import { CoreError, assertSafeInt } from './errors'

/**
 * Integer division rounded half away from zero — exactly what Postgres
 * `round(numeric)` does, so amounts match the database CHECK constraints.
 * Uses BigInt so intermediate products (qty × price) can't lose precision.
 */
export function divRound(numerator: bigint, denominator: bigint): bigint {
  if (denominator === 0n) throw new CoreError('invalid_input', 'division by zero')
  if (denominator < 0n) {
    numerator = -numerator
    denominator = -denominator
  }
  const q = numerator / denominator // truncates toward zero
  const r = numerator % denominator
  const twiceAbsR = (r < 0n ? -r : r) * 2n
  if (twiceAbsR >= denominator) return numerator < 0n ? q - 1n : q + 1n
  return q
}

/** `round(a * b / d)` for safe integers, half away from zero. */
export function mulDivRound(a: number, b: number, d: number): number {
  assertSafeInt(a, 'a')
  assertSafeInt(b, 'b')
  assertSafeInt(d, 'd')
  return toSafeNumber(divRound(BigInt(a) * BigInt(b), BigInt(d)))
}

export function toSafeNumber(value: bigint): number {
  const n = Number(value)
  if (!Number.isSafeInteger(n))
    throw new CoreError('overflow', `${value} exceeds the safe integer range`)
  return n
}
